import axios from 'axios'
import {DateTime} from "luxon";

const removeOpenPropertyFromFoldersStructure = (folders) => {

    for (let folder of folders) {
        if (folder.hasOwnProperty('Open')) {
            delete folder.Open;
        }
        if (folder.hasOwnProperty('SubItems') && folder.SubItems.length > 0) {
            removeOpenPropertyFromFoldersStructure(folder.SubItems);
        }
    }

    return folders;
}

const addOpenPropertyFromFoldersStructure = (folders) => {

    for (let folder of folders) {
        if (!folder.hasOwnProperty('Open')) {
            folder.Open = false;
        }
        if (!folder.hasOwnProperty('Picture')) {
            folder.Picture = null;
        }
        if (folder.hasOwnProperty('SubItems') && folder.SubItems.length > 0) {
            addOpenPropertyFromFoldersStructure(folder.SubItems);
        }
    }

    return folders;
}

const getDefaultState = () => {
    return {
        userPreferences: {
            ID: null,
            UserID: null,
            Language: 'en',
            TreasureChestFilters: {
                Types: [],
                Sources: [],
                Tags: []
            },
            Tags: [],
            JourneysNotes: [],
            LastJourneyID: '',
            ExtraAttributes: {},
            SidebarDropzoneElements: {
                StructureItems: [],
                Units: []
            },
            UserTimezone: null,
            FoldersStructure: [],
            PreferredEmailTemplates: {},
            JourneyTags: [],
        },
        activeFolderPath: [],
    }
};

const state = getDefaultState();

const getters = {
    getLanguage: state => state.userPreferences.Language,
    getTags: state => state.userPreferences.Tags,
    getLastJourneyID: state => state.userPreferences.LastJourneyID,
    getUserExtraAttributes: state => state.userPreferences.ExtraAttributes,
    getSidebarDropzoneElements: state => state.userPreferences.SidebarDropzoneElements,
    getUserTimezone: state => state.userPreferences.UserTimezone,
    getFoldersStructure: state => state.userPreferences.FoldersStructure,
    getActiveFolderPath: state => state.activeFolderPath,
    getPreferredEmailTemplates: state => state.userPreferences.PreferredEmailTemplates,
    getUserPreferencesID: state => state.userPreferences.ID,
    getJourneyTags: state => state.userPreferences.JourneyTags || [],
}

const actions = {

    async fetchUserPreferences({commit, dispatch, state, rootState}) {
        // If offline and we have cached data, return it
        if (!navigator.onLine && state.userPreferences && state.userPreferences.ID) {
            console.log('Offline: Using cached user preferences');
            return state.userPreferences;
        }

        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {

            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let payloadAPI = {

            };

            const response = await axios.post(`/v2/user-preferences/get`, payloadAPI, config);

            let userPreferences = response.data.userPreferences;

            userPreferences.SidebarDropzoneElements.StructureItems.forEach((StructureItem) => {

                if (StructureItem.Type === 'Chapter') {

                    if (StructureItem.hasOwnProperty('Units')) {

                        StructureItem.Units.forEach((Unit, indexUnit) => {

                            if (Unit.hasOwnProperty('Blocks')) {
                                Unit.Blocks.forEach((Block) => {
                                    if (Block.hasOwnProperty('Elements')) {
                                        Block.Elements.forEach((Element) => {

                                            if (Element.type === 'columns' && Element.data && Element.data.columns) {

                                                for (let Column of Element.data.columns) {

                                                    // parse editor data for columns to avoid nesting error
                                                    if (typeof Column.editorData === 'string') {
                                                        Column.editorData = JSON.parse(Column.editorData);
                                                    }
                                                }
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    }
                }

                if (StructureItem.Type === 'Event') {

                    if (StructureItem.hasOwnProperty('Details') && StructureItem.Details.hasOwnProperty('Elements') && StructureItem.Details.Elements.length > 0) {
                        StructureItem.Details.Elements.forEach((Element) => {

                            if (Element.type === 'columns' && Element.data && Element.data.columns) {

                                for (let Column of Element.data.columns) {
                                    // parse editor data for columns to avoid nesting error
                                    if (typeof Column.editorData === 'string') {
                                        Column.editorData = JSON.parse(Column.editorData);
                                    }
                                }
                            }
                        });
                    }

                    if (StructureItem.hasOwnProperty('Assignment')) {

                        if (StructureItem.Assignment.hasOwnProperty('ID') && StructureItem.Assignment.ID !== null) {

                            if (StructureItem.Assignment.Type === 'Checklist') {

                                StructureItem.Assignment.Content.Tasks.forEach((Task) => {

                                    if (Task.hasOwnProperty('Content') && Task.Content.hasOwnProperty('Elements') && Task.Content.Elements.length > 0) {

                                        Task.Content.Elements.forEach((TaskElement) => {

                                            if (TaskElement.type === 'columns' && TaskElement.data && TaskElement.data.columns) {

                                                for (let Column of TaskElement.data.columns) {

                                                    // parse editor data for columns to avoid nesting error
                                                    if (typeof Column.editorData === 'string') {
                                                        Column.editorData = JSON.parse(Column.editorData);
                                                    }
                                                }
                                            }
                                        });
                                    }
                                });
                            }
                        }
                    }
                }
            });

            userPreferences.SidebarDropzoneElements.Units.forEach((Unit) => {

                if (Unit.hasOwnProperty('Blocks')) {
                    Unit.Blocks.forEach((Block) => {
                        if (Block.hasOwnProperty('Elements')) {
                            Block.Elements.forEach((Element) => {

                                if (Element.type === 'columns' && Element.data && Element.data.columns) {

                                    for (let Column of Element.data.columns) {

                                        // parse editor data for columns to avoid nesting error
                                        if (typeof Column.editorData === 'string') {
                                            Column.editorData = JSON.parse(Column.editorData);
                                        }
                                    }
                                }
                            });
                        }
                    });
                }


            });

            userPreferences.FoldersStructure = addOpenPropertyFromFoldersStructure(userPreferences.FoldersStructure);

            if (!Array.isArray(userPreferences.JourneyTags)) {
                userPreferences.JourneyTags = [];
            }


            if (!userPreferences.hasOwnProperty('UserTimezone') || userPreferences.UserTimezone === undefined || userPreferences.UserTimezone === null || userPreferences.UserTimezone === '') {

                try {
                    const currentUserTimezone = DateTime.local().zoneName;

                    let payloadUpdateUserTimezone = {
                        ID: userPreferences.ID,
                        UserTimezone: currentUserTimezone
                    };

                    await axios.post(`/v2/user-preferences/update-user-timezone`, payloadUpdateUserTimezone, config);
                    userPreferences.UserTimezone = currentUserTimezone;
                }

                catch (err) {
                    dispatch('notifications/addNotification', {
                        type: 'error',
                        message: 'Failed to save user timezone'
                    }, {root: true});
                }

            }

            commit('PUSH_USER_PREFERENCES', userPreferences);

        }
        catch (err) {
            // If offline and fetch failed, return cached data if available
            if (!navigator.onLine && state.userPreferences && state.userPreferences.ID) {
                console.log('Offline: Fetch failed, using cached user preferences');
                return state.userPreferences;
            }
            dispatch('notifications/addNotification', {
                type: 'error',
                message: 'Failed to fetch user preferences'
            }, {root: true});
        }

    },

    async updateLanguage({commit, dispatch, state, rootState}, language) {

        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {

            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let payloadAPI = {
                ID: state.userPreferences.ID,
                Language: language
            };

            await axios.post(`/v2/user-preferences/update-language`, payloadAPI, config);

            commit('UPDATE_LANGUAGE', language);

        }
        catch (err) {
            commit('UPDATE_LANGUAGE', language);
        }

    },

    async updateTreasureChestFilters({commit, dispatch, state, rootState}, payload) {

        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {

            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let payloadAPI = {
                ID: state.userPreferences.ID,
                TreasureChestFilters: payload.TreasureChestFilters
            };

            await axios.post(`/v2/user-preferences/update-treasure-chest-filters`, payloadAPI, config);

            commit('UPDATE_TREASURE_CHEST_FILTERS', payload.TreasureChestFilters);

        }
        catch (err) {
            commit('UPDATE_TREASURE_CHEST_FILTERS', payload.TreasureChestFilters);
        }

    },

    async updateTags({commit, dispatch, state, rootState}, payload) {

        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {

            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let existingTags = JSON.parse(JSON.stringify(state.userPreferences.Tags));

            if (!existingTags.includes(payload.NewTag)) {
                existingTags.push(payload.NewTag);

                let payloadAPI = {
                    ID: state.userPreferences.ID,
                    Tags: existingTags
                };

                await axios.post(`/v2/user-preferences/update-tags`, payloadAPI, config);

                commit('UPDATE_TAGS', existingTags);
            }

        }
        catch (err) {
            dispatch('notifications/addNotification', {
                type: 'error',
                message: 'Something went wrong!'
            }, {root: true});
        }

    },

    async updateLastJourneyID({commit, dispatch, state, rootState}, payload) {

        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        if (state.userPreferences.ID === null) {
            await dispatch('fetchUserPreferences');
        }

        commit('UPDATE_LAST_JOURNEY_ID', payload.LastJourneyID);

        if (state.userPreferences.ID == null) {
            console.warn('updateLastJourneyID: no preferences ID, skipped API sync');
            return;
        }

        try {
            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let payloadAPI = {
                ID: state.userPreferences.ID,
                LastJourneyID: payload.LastJourneyID
            };

            await axios.post(`/v2/user-preferences/update-last-journey-id`, payloadAPI, config);
        }
        catch (err) {
            console.warn('updateLastJourneyID: API sync failed, local persisted value kept', err);
        }

    },

    async updateJourneysNotes({commit, dispatch, state, rootState}, payload) {

        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {

            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let payloadAPI = {
                ID: state.userPreferences.ID,
                JourneysNotes: payload.JourneysNotes
            };

            await axios.post(`/v2/user-preferences/update-journeys-notes`, payloadAPI, config);

            commit('UPDATE_JOURNEYS_NOTES', payload.JourneysNotes);

        }
        catch (err) {
            commit('UPDATE_JOURNEYS_NOTES', payload.JourneysNotes);
        }

    },

    async updateSidebarDropzoneElements({commit, dispatch, state, rootState}, payload) {

        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {

            if (!payload.SkipDatabaseSave) {

                // remove images URLs
                payload.SidebarDropzoneElements.StructureItems.forEach((StructureItem) => {

                    if (StructureItem.Type === 'Chapter') {

                        if (StructureItem.hasOwnProperty('Units')) {

                            StructureItem.Units.forEach((Unit, indexUnit) => {

                                if (Unit.hasOwnProperty('LinkedAssets')) {

                                    Unit.LinkedAssets.forEach((linkedAsset, indexLinkedAsset) => {

                                        if (linkedAsset.Type === 'Attachment') {

                                            Unit.LinkedAssets[indexLinkedAsset] = {
                                                Type: linkedAsset.Type,
                                                Name: `${linkedAsset.Name}`,
                                                Label: linkedAsset.Label,
                                                IsTreasureChestAsset: linkedAsset.IsTreasureChestAsset,
                                                FolderName: `journey/${StructureItem.SourceJourneyID}/assets`
                                            }

                                        }

                                        if (linkedAsset.Type === 'MemoryCard') {
                                            let memoryCardSaveObject = {
                                                Type: linkedAsset.Type,
                                                BatchNumber: linkedAsset.BatchNumber,
                                                MemoryCardNumber: linkedAsset.MemoryCardNumber,
                                                IsTreasureChestAsset: linkedAsset.IsTreasureChestAsset,
                                            }
                                            Unit.LinkedAssets[indexLinkedAsset] = memoryCardSaveObject;
                                        }

                                        if (linkedAsset.Type === 'ExpeditionLog') {
                                            let expeditionLogSaveObject = {
                                                Type: linkedAsset.Type,
                                                ExpeditionLogNumber: linkedAsset.ExpeditionLogNumber,
                                                IsTreasureChestAsset: linkedAsset.IsTreasureChestAsset,
                                            }
                                            Unit.LinkedAssets[indexLinkedAsset] = expeditionLogSaveObject;
                                        }

                                    });
                                }

                                if (Unit.hasOwnProperty('Blocks')) {
                                    Unit.Blocks.forEach((Block) => {
                                        if (Block.hasOwnProperty('Elements')) {
                                            Block.Elements.forEach((Element) => {

                                                if (Element.type === 'image' && Element.data.file.hasOwnProperty('url')) {
                                                    delete Element.data.file.url;
                                                }

                                                if (Element.type === 'reusableImage' && Element.data.file.hasOwnProperty('url')) {
                                                    delete Element.data.file.url;
                                                }

                                                if (Element.type === 'columns' && Element.data && Element.data.columns) {

                                                    for (let Column of Element.data.columns) {

                                                        // parse editor data for columns to avoid nesting error
                                                        if (typeof Column.editorData === 'string') {
                                                            Column.editorData = JSON.parse(Column.editorData);
                                                        }

                                                        for (let ColumnElement of Column.editorData.blocks) {

                                                            if (ColumnElement.type === 'image' && ColumnElement.data.file.hasOwnProperty('url')) {
                                                                delete ColumnElement.data.file.url;
                                                            }

                                                            if (ColumnElement.type === 'reusableImage' && ColumnElement.data.file.hasOwnProperty('url')) {
                                                                delete ColumnElement.data.file.url;
                                                            }

                                                        }

                                                        // serialize editor data for columns to avoid nesting error
                                                        if (typeof Column.editorData !== 'string') {
                                                            Column.editorData = JSON.stringify(Column.editorData);
                                                        }

                                                    }

                                                }

                                            });
                                        }
                                    });
                                }

                            });

                        }

                    }

                    if (StructureItem.Type === 'Event') {

                        if (StructureItem.hasOwnProperty('LinkedAssets')) {

                            StructureItem.LinkedAssets.forEach((linkedAsset, indexLinkedAsset) => {

                                if (linkedAsset.Type === 'Attachment') {

                                    StructureItem.LinkedAssets[indexLinkedAsset] = {
                                        Type: linkedAsset.Type,
                                        Name: `${linkedAsset.Name}`,
                                        Label: linkedAsset.Label,
                                        IsTreasureChestAsset: linkedAsset.IsTreasureChestAsset,
                                        FolderName: `journey/${StructureItem.SourceJourneyID}/assets`
                                    }

                                }

                                if (linkedAsset.Type === 'MemoryCard') {
                                    let memoryCardSaveObject = {
                                        Type: linkedAsset.Type,
                                        BatchNumber: linkedAsset.BatchNumber,
                                        MemoryCardNumber: linkedAsset.MemoryCardNumber,
                                        IsTreasureChestAsset: linkedAsset.IsTreasureChestAsset,
                                    }
                                    StructureItem.LinkedAssets[indexLinkedAsset] = memoryCardSaveObject;
                                }

                                if (linkedAsset.Type === 'ExpeditionLog') {
                                    let expeditionLogSaveObject = {
                                        Type: linkedAsset.Type,
                                        ExpeditionLogNumber: linkedAsset.ExpeditionLogNumber,
                                        IsTreasureChestAsset: linkedAsset.IsTreasureChestAsset,
                                    }
                                    StructureItem.LinkedAssets[indexLinkedAsset] = expeditionLogSaveObject;
                                }

                            });
                        }

                        if (StructureItem.hasOwnProperty('Details') && StructureItem.Details.hasOwnProperty('Elements') && StructureItem.Details.Elements.length > 0) {
                            StructureItem.Details.Elements.forEach((Element) => {

                                if (Element.type === 'image' && Element.data.file.hasOwnProperty('url')) {
                                    delete Element.data.file.url;
                                }

                                if (Element.type === 'reusableImage' && Element.data.file.hasOwnProperty('url')) {
                                    delete Element.data.file.url;
                                }

                                if (Element.type === 'columns' && Element.data && Element.data.columns) {

                                    for (let Column of Element.data.columns) {

                                        // parse editor data for columns to avoid nesting error
                                        if (typeof Column.editorData === 'string') {
                                            Column.editorData = JSON.parse(Column.editorData);
                                        }

                                        for (let ColumnElement of Column.editorData.blocks) {

                                            if (ColumnElement.type === 'image' && ColumnElement.data.file.hasOwnProperty('url')) {
                                                delete ColumnElement.data.file.url;
                                            }

                                            if (ColumnElement.type === 'reusableImage' && ColumnElement.data.file.hasOwnProperty('url')) {
                                                delete ColumnElement.data.file.url;
                                            }

                                        }

                                        // serialize editor data for columns to avoid nesting error
                                        if (typeof Column.editorData !== 'string') {
                                            Column.editorData = JSON.stringify(Column.editorData);
                                        }

                                    }

                                }


                            });
                        }

                        if (StructureItem.hasOwnProperty('Assignment')) {

                            if (StructureItem.Assignment.hasOwnProperty('ID') && StructureItem.Assignment.ID !== null) {

                                if (StructureItem.Assignment.Type === 'Checklist') {

                                    StructureItem.Assignment.Content.Tasks.forEach((Task) => {

                                        if (Task.hasOwnProperty('Content') && Task.Content.hasOwnProperty('Elements') && Task.Content.Elements.length > 0) {

                                            Task.Content.Elements.forEach((TaskElement) => {

                                                if (TaskElement.type === 'image' && TaskElement.data.file.hasOwnProperty('url')) {
                                                    delete TaskElement.data.file.url;
                                                }

                                                if (TaskElement.type === 'reusableImage' && TaskElement.data.file.hasOwnProperty('url')) {
                                                    delete TaskElement.data.file.url;
                                                }

                                                if (TaskElement.type === 'columns' && TaskElement.data && TaskElement.data.columns) {

                                                    for (let Column of TaskElement.data.columns) {

                                                        // parse editor data for columns to avoid nesting error
                                                        if (typeof Column.editorData === 'string') {
                                                            Column.editorData = JSON.parse(Column.editorData);
                                                        }

                                                        for (let ColumnElement of Column.editorData.blocks) {

                                                            if (ColumnElement.type === 'image' && TaskElement.data.file.hasOwnProperty('url')) {
                                                                delete TaskElement.data.file.url;
                                                            }

                                                            if (ColumnElement.type === 'reusableImage' && TaskElement.data.file.hasOwnProperty('url')) {
                                                                delete TaskElement.data.file.url;
                                                            }

                                                        }

                                                        // serialize editor data for columns to avoid nesting error
                                                        if (typeof Column.editorData !== 'string') {
                                                            Column.editorData = JSON.stringify(Column.editorData);
                                                        }

                                                    }
                                                }

                                            });
                                        }
                                    });

                                }

                            }

                        }

                    }
                });

                payload.SidebarDropzoneElements.Units.forEach((Unit) => {

                    if (Unit.hasOwnProperty('LinkedAssets')) {

                        Unit.LinkedAssets.forEach((linkedAsset, indexLinkedAsset) => {

                            if (linkedAsset.Type === 'Attachment') {

                                Unit.LinkedAssets[indexLinkedAsset] = {
                                    Type: linkedAsset.Type,
                                    Name: `${linkedAsset.Name}`,
                                    Label: linkedAsset.Label,
                                    IsTreasureChestAsset: linkedAsset.IsTreasureChestAsset,
                                    FolderName: `journey/${Unit.SourceJourneyID}/assets`
                                }

                            }

                            if (linkedAsset.Type === 'MemoryCard') {
                                let memoryCardSaveObject = {
                                    Type: linkedAsset.Type,
                                    BatchNumber: linkedAsset.BatchNumber,
                                    MemoryCardNumber: linkedAsset.MemoryCardNumber,
                                    IsTreasureChestAsset: linkedAsset.IsTreasureChestAsset,
                                }
                                Unit.LinkedAssets[indexLinkedAsset] = memoryCardSaveObject;
                            }

                            if (linkedAsset.Type === 'ExpeditionLog') {
                                let expeditionLogSaveObject = {
                                    Type: linkedAsset.Type,
                                    ExpeditionLogNumber: linkedAsset.ExpeditionLogNumber,
                                    IsTreasureChestAsset: linkedAsset.IsTreasureChestAsset,
                                }
                                Unit.LinkedAssets[indexLinkedAsset] = expeditionLogSaveObject;
                            }

                        });
                    }

                    if (Unit.hasOwnProperty('Blocks')) {
                        Unit.Blocks.forEach((Block) => {
                            if (Block.hasOwnProperty('Elements')) {
                                Block.Elements.forEach((Element) => {

                                    if (Element.type === 'image' && Element.data.file.hasOwnProperty('url')) {
                                        delete Element.data.file.url;
                                    }

                                    if (Element.type === 'reusableImage' && Element.data.file.hasOwnProperty('url')) {
                                        delete Element.data.file.url;
                                    }

                                    if (Element.type === 'columns' && Element.data && Element.data.columns) {

                                        for (let Column of Element.data.columns) {

                                            // parse editor data for columns to avoid nesting error
                                            if (typeof Column.editorData === 'string') {
                                                Column.editorData = JSON.parse(Column.editorData);
                                            }

                                            for (let ColumnElement of Column.editorData.blocks) {

                                                if (ColumnElement.type === 'image' && ColumnElement.data.file.hasOwnProperty('url')) {
                                                    delete ColumnElement.data.file.url;
                                                }

                                                if (ColumnElement.type === 'reusableImage' && ColumnElement.data.file.hasOwnProperty('url')) {
                                                    delete ColumnElement.data.file.url;
                                                }

                                            }

                                            // serialize editor data for columns to avoid nesting error
                                            if (typeof Column.editorData !== 'string') {
                                                Column.editorData = JSON.stringify(Column.editorData);
                                            }

                                        }

                                    }

                                });
                            }
                        });
                    }


                });

                let config = {
                    headers: {
                        Authorization: rootState.auth.bearer
                    },
                };

                let payloadAPI = {
                    ID: state.userPreferences.ID,
                    SidebarDropzoneElements: payload.SidebarDropzoneElements
                };

                await axios.post(`/v2/user-preferences/update-sidebar-dropzone-elements`, payloadAPI, config);

                // dispatch('notifications/addNotification', {
                //     type: 'success',
                //     message: 'Dropzone updated successfully'
                // }, {root: true});

            }

            commit('UPDATE_SIDEBAR_DROPZONE_ELEMENTS', payload.SidebarDropzoneElements);

        }
        catch (err) {
            commit('UPDATE_SIDEBAR_DROPZONE_ELEMENTS', payload.SidebarDropzoneElements);
            dispatch('notifications/addNotification', {
                type: 'error',
                message: 'Failed to update dropzone'
            }, {root: true});
        }

    },

    async updateUserTimezone({commit, dispatch, state, rootState}, payload) {

        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {

            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };


            if (state.userPreferences.ID === null) {
                await dispatch('fetchUserPreferences');
            }

            let payloadAPI = {
                ID: state.userPreferences.ID,
                UserTimezone: payload.UserTimezone
            };

            await axios.post(`/v2/user-preferences/update-user-timezone`, payloadAPI, config);

            commit('UPDATE_USER_TIMEZONE', payload.UserTimezone);

            dispatch('notifications/addNotification', {
                type: 'success',
                message: 'Timezone updated successfully'
            }, {root: true});

        }
        catch (err) {

            commit('UPDATE_USER_TIMEZONE', payload.UserTimezone);

            dispatch('notifications/addNotification', {
                type: 'error',
                message: 'Failed to update timezone'
            }, {root: true});

        }

    },

    async updateFoldersStructure({commit, dispatch, state, rootState}, payload) {

        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {

            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let foldersStructureNoReference = JSON.parse(JSON.stringify(payload.FoldersStructure));

            let payloadAPI = {
                ID: state.userPreferences.ID,
                FoldersStructure: removeOpenPropertyFromFoldersStructure(foldersStructureNoReference),
            };

            await axios.post(`/v2/user-preferences/update-folders-structure`, payloadAPI, config);

            commit('UPDATE_FOLDERS_STRUCTURE', payload.FoldersStructure);

            dispatch('notifications/addNotification', {
                type: 'success',
                message: 'Folder structure updated successfully'
            }, {root: true});

        }
        catch (err) {
            // commit('UPDATE_FOLDERS_STRUCTURE', payload.FoldersStructure);
            dispatch('notifications/addNotification', {
                type: 'success',
                message: 'Folders structure failed to be updated'
            }, {root: true});
        }

    },

    async updatePreferredEmailTemplates({commit, dispatch, state, rootState}, preferredEmailTemplates) {

        if (state.userPreferences.ID === null) {
            await dispatch('fetchUserPreferences');
        }

        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {

            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let payloadAPI = {
                ID: state.userPreferences.ID,
                PreferredEmailTemplates: preferredEmailTemplates,
            };

            await axios.post(`/v2/user-preferences/update-preferred-email-templates`, payloadAPI, config);

            commit('UPDATE_PREFERRED_EMAIL_TEMPLATES', preferredEmailTemplates);

        }
        catch (err) {
            commit('UPDATE_PREFERRED_EMAIL_TEMPLATES', preferredEmailTemplates);
        }

    },

    // returns true on success so the caller can show its own (translated) notification,
    // or the notification key of a known refusal (e.g. tagging a journey the user isn't allowed to tag), false otherwise
    async updateJourneyTags({commit, dispatch, state, rootState}, journeyTags) {

        if (state.userPreferences.ID === null) {
            await dispatch('fetchUserPreferences');
        }

        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {

            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let payloadAPI = {
                ID: state.userPreferences.ID,
                JourneyTags: journeyTags,
            };

            await axios.post(`/v2/user-preferences/update-journey-tags`, payloadAPI, config);

            commit('UPDATE_JOURNEY_TAGS', journeyTags);

            return true;

        }
        catch (err) {
            if (err.response && err.response.data && err.response.data.journeyTagNotAllowed) {
                return 'notifications.journeyTagNotAllowed';
            }
            return false;
        }

    },

    async updateUserExtraAttributes({commit, dispatch, state, rootState}, payload) {

        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {

            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let stateExtraAttributes = {};

            if (state.userPreferences.ExtraAttributes !== undefined) {
                stateExtraAttributes = JSON.parse(JSON.stringify(state.userPreferences.ExtraAttributes));
            }

            Object.assign(stateExtraAttributes, payload);

            let payloadAPI = {
                ID: state.userPreferences.ID,
                ExtraAttributes: stateExtraAttributes
            };

            await axios.post(`/v2/user-preferences/update-user-extra-attributes`, payloadAPI, config);

            commit('UPDATE_EXTRA_ATTRIBUTES', stateExtraAttributes);

        }
        catch (err) {
            commit('UPDATE_EXTRA_ATTRIBUTES', payload.ExtraAttributes);
        }

    },
    async updateUserExtraAttributesStripeCustomerID({commit, dispatch, state, rootState}, payload) {

        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        try {

            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let stateExtraAttributes = {};

            if (state.userPreferences.ExtraAttributes !== undefined) {
                stateExtraAttributes = JSON.parse(JSON.stringify(state.userPreferences.ExtraAttributes));
            }

            Object.assign(stateExtraAttributes, payload);

            let payloadAPI = {
                ID: state.userPreferences.ID,
                ExtraAttributes: stateExtraAttributes
            };

            await axios.post(`/v2/user-preferences/update-user-extra-attributes`, payloadAPI, config);

            commit('UPDATE_EXTRA_ATTRIBUTES', stateExtraAttributes);

        }
        catch (err) {
            commit('UPDATE_EXTRA_ATTRIBUTES', payload.ExtraAttributes);
        }

    },

    // async addExistingUsersToUserPreferencesTable({commit, dispatch, rootState}) {
    //     axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;
    //
    //     try {
    //
    //         let config = {
    //             headers: {
    //                 Authorization: rootState.auth.bearer
    //             },
    //         };
    //
    //         let payloadAPI = {
    //
    //         };
    //
    //         const response = await axios.post(`/do-not-push/add-existing-users-to-user-preferences-table`, payloadAPI, config);
    //
    //         console.log(response.data.userPreferences);
    //
    //     }
    //     catch (err) {
    //     }
    // }

}

const mutations = {

    PUSH_USER_PREFERENCES: (state, userPreferences) => {
        state.userPreferences = userPreferences;
    },

    UPDATE_LANGUAGE: (state, language) => {
        state.userPreferences.Language = language;
    },

    UPDATE_TREASURE_CHEST_FILTERS: (state, treasureChestFilters) => {
        state.userPreferences.TreasureChestFilters = treasureChestFilters;
    },

    UPDATE_TAGS: (state, journeysTags) => {
        state.userPreferences.Tags = journeysTags;
    },

    UPDATE_JOURNEYS_NOTES: (state, journeysNotes) => {
        state.userPreferences.JourneysNotes = journeysNotes;
    },

    UPDATE_SIDEBAR_DROPZONE_ELEMENTS: (state, sidebarDropzoneElements) => {
        state.userPreferences.SidebarDropzoneElements = sidebarDropzoneElements;
    },

    UPDATE_LAST_JOURNEY_ID: (state, LastJourneyID) => {
        state.userPreferences.LastJourneyID = LastJourneyID;
    },

    UPDATE_EXTRA_ATTRIBUTES: (state, ExtraAttributes) => {
        state.userPreferences.ExtraAttributes = ExtraAttributes;
    },

    UPDATE_USER_TIMEZONE: (state, UserTimezone) => {
        state.userPreferences.UserTimezone = UserTimezone;
    },

    UPDATE_FOLDERS_STRUCTURE: (state, foldersStructure) => {
        state.userPreferences.FoldersStructure = foldersStructure;
    },

    UPDATE_PREFERRED_EMAIL_TEMPLATES: (state, preferredEmailTemplates) => {
        state.userPreferences.PreferredEmailTemplates = preferredEmailTemplates;
    },

    UPDATE_JOURNEY_TAGS: (state, journeyTags) => {
        state.userPreferences.JourneyTags = journeyTags;
    },

    SET_ACTIVE_FOLDER_PATH(state, path) {
        state.activeFolderPath = path;
    },


    RESET_STATE(state) {
        Object.assign(state, getDefaultState());
      },

    // DELETE_USER_NOTIFICATION: (state, userNotificationID) => {
    //     state.userNotifications = state.userNotifications.filter((userNotification) => {
    //         return userNotification.ID !== userNotificationID;
    //     })
    // }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
